var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"truncateCustomerAccount"},on),[_vm._v(" "+_vm._s(_vm.data.customer_Account)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.data.customer_Account))])])
}
var staticRenderFns = []

export { render, staticRenderFns }